// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lang[data-v-293f1ef1]{width:100%}.lang[data-v-293f1ef1] .el-form-item__content{width:79%}.tagForm[data-v-293f1ef1]{margin:20px}", ""]);
// Exports
module.exports = exports;
